
import { useNavigate } from 'react-router-dom';

export default function QuickActions() {
  const navigate = useNavigate();

  const actions = [
    {
      icon: 'ri-send-plane-line',
      title: 'تحويل جديد',
      subtitle: 'إرسال أموال',
      color: 'bg-blue-600',
      action: () => navigate('/transfer')
    },
    {
      icon: 'ri-history-line',
      title: 'السجل',
      subtitle: 'التحويلات السابقة',
      color: 'bg-green-600',
      action: () => navigate('/history')
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'التقارير',
      subtitle: 'الإحصائيات المالية',
      color: 'bg-purple-600',
      action: () => navigate('/reports')
    },
    {
      icon: 'ri-customer-service-line',
      title: 'الدعم',
      subtitle: 'تواصل معنا',
      color: 'bg-orange-600',
      action: () => {}
    }
  ];

  return (
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">الإجراءات السريعة</h2>
      <div className="grid grid-cols-2 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.action}
            className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className={`w-12 h-12 ${action.color} rounded-full flex items-center justify-center mb-3`}>
              <i className={`${action.icon} text-white text-xl`}></i>
            </div>
            <h3 className="font-medium text-gray-800 text-sm">{action.title}</h3>
            <p className="text-xs text-gray-600 mt-1">{action.subtitle}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
